var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z",
    fill: "#E41E42"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.012 22.4571L16.8301 21.6872L22.3305 16.1868C22.721 15.7963 22.721 15.1631 22.3305 14.7726L22.1106 14.5527C21.7193 14.1614 21.0846 14.1623 20.6944 14.5547L17.1428 18.1263V7C17.1428 6.44772 16.6951 6 16.1428 6H15.8812C15.3289 6 14.8812 6.44772 14.8812 7V18.1263L11.3296 14.5547C10.9394 14.1623 10.3047 14.1614 9.91344 14.5527L9.69356 14.7726C9.30303 15.1631 9.30303 15.7963 9.69356 16.1868L15.194 21.6872L16.012 22.4571Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8692 23.179H9.13083C8.50629 23.179 8 23.6852 8 24.3098C8 24.9343 8.50629 25.4406 9.13083 25.4406H22.8692C23.4937 25.4406 24 24.9343 24 24.3098C24 23.6852 23.4937 23.179 22.8692 23.179Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadFilled);
export default __webpack_public_path__ + "static/media/Download Filled.f07a620914663206c9b15c468373f97f.svg";
export { ForwardRef as ReactComponent };